import { css } from '@sorare/css';

import { Horizontal, Vertical } from '#src/atoms/layout/flex/index.tsx';
import { StarkwareEscapeHatch } from '#src/components/wallet/StarkwareEscapeHatch/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

import { CryptoBalance } from './CryptoBalance/index.tsx';
import { Deposit } from './Deposit/index.tsx';
import { FiatBalance } from './FiatBalance/index.tsx';

const root = css`
  border: 1px solid var(--c-ui-primary);
  border-radius: var(--unit);
`;
const horizontal = css`
  border-bottom: 1px solid var(--c-ui-primary);
  & > * {
    flex: 1;
    padding: var(--unit);
    text-align: center;
  }
  .sidebarCollapsed & {
    flex-direction: column;

    & > * {
      width: 100%;
      padding: var(--unit) var(--half-unit);
    }

    & > :first-child {
      border-bottom: 1px solid var(--c-ui-primary);
      border-right: none;
    }
  }

  & > :first-child {
    border-right: 1px solid var(--c-ui-primary);
  }
  &:hover {
    background-color: var(--c-surface-primary);
  }

  transition:
    300ms background-color ease-in-out,
    300ms color ease-in-out,
    300ms border-color ease-in-out;
`;

type Props = { onClick?: () => void; sidebarCollapsed?: boolean };
export const MoneyBalances = ({ onClick, sidebarCollapsed }: Props) => {
  const {
    walletPreferences: { showCryptoWallet },
  } = useCurrentUserContext();

  return (
    <Vertical className={root} gap={0}>
      <Horizontal className={horizontal} gap={0}>
        <button onClick={onClick} type="button">
          <FiatBalance collapsed={sidebarCollapsed} />
        </button>
        {!!showCryptoWallet && (
          <button onClick={onClick} type="button">
            <CryptoBalance collapsed={sidebarCollapsed} />
          </button>
        )}
      </Horizontal>
      <StarkwareEscapeHatch
        layout={sidebarCollapsed ? 'collapsed' : 'expanded'}
      />
      <Deposit onClick={onClick} sidebarCollapsed={sidebarCollapsed} />
    </Vertical>
  );
};
